import { injectOAuthParams } from '@autoinspector/detail/hooks/useApiClient'
import { hydrateRequestHeaders } from '@autoinspector/providers/autoinspector'
import axios, { AxiosError } from 'axios'
import Router from 'next/router'
import { toast } from 'react-toastify'
import { ErrorsCodes } from 'source-of-truth/errorsCodes'
import { messages } from 'source-of-truth/messages'

const proxyUrl = process.env.NEXT_PUBLIC_HTTP_PROXY

let proxyAgent: any
if (proxyUrl && typeof window === 'undefined') {
  // require inside the server-only branch avoids bundling `net` into the client
  const { HttpProxyAgent } = require('http-proxy-agent')
  proxyAgent = new HttpProxyAgent(proxyUrl)
}

axios.defaults.withCredentials = true

const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  withCredentials: true,
  ...(proxyAgent ? { httpAgent: proxyAgent } : {}),
})

instance.interceptors.request.use(
  (request) => {
    if (typeof window !== 'undefined') {
      const searchParams = new URLSearchParams(window.location.search)
      injectOAuthParams(request, searchParams)
      hydrateRequestHeaders(request)
    }

    return request
  },
  (error) => {
    console.log('error', error)
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error: Error | AxiosError) => {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 401) {
        if (typeof window !== 'undefined' && 'Intercom' in window) {
          console.log('exists INTERCOM')
          window.Intercom('shutdown')
          Router.push('/login')
        }
      }

      if (error.response?.data?.code === ErrorsCodes.COMPANY_NOT_VERIFIED_YET) {
        toast(messages[ErrorsCodes.COMPANY_NOT_VERIFIED_YET])
      }
    }
    return Promise.reject(error)
  },
)

export default instance
